export enum GfpType {
  Inter = 'I',
  Klok = 'K'
}

export const GfpTypeMap: {
  [key in GfpType]: string;
} = {
  [GfpType.Inter]: 'INTER',
  [GfpType.Klok]: 'KLOK'
};

export const GfpFullTypeMap: {
  [key in GfpType]: string;
} = {
  [GfpType.Inter]: 'Intermediação',
  [GfpType.Klok]: 'Klok'
};
